import { gql } from 'graphql-request';

import {
  CompanyTabCompanyID,
  CompanyTabCreatedAt,
  CompanyTabID,
  CompanyTabName,
  CompanyTabNanoID,
  CompanyTabPosition,
  CompanyTabType,
  CompanyTabUpdatedAt,
  CompanyTabUser,
  CompanyTabUserID,
  CompanyTabUUID
} from '../companyTabsTypes';

export interface FetchCompanyTabsQueryResponse {
  id: CompanyTabID;
  uuid: CompanyTabUUID;
  nanoId: CompanyTabNanoID;
  name: CompanyTabName;
  content: string | null;
  position: CompanyTabPosition;
  type: CompanyTabType;
  createdAt: CompanyTabCreatedAt;
  updatedAt: CompanyTabUpdatedAt;
  userId: CompanyTabUserID;
  user: CompanyTabUser;
  companyId: CompanyTabCompanyID;
}

export const FETCH_COMPANY_TABS_QUERY = gql`
  query CompanyTabs(
    $filters: CompanyTabsFilters
    $limit: Int
    $offset: Int
    $sort: [CompanyTabsSortEnum!]
  ) {
    companyTabs(
      filters: $filters
      limit: $limit
      offset: $offset
      sort: $sort
    ) {
      nodes {
        content
        createdAt
        id
        name
        nanoId
        position
        type
        updatedAt
        userId
        uuid
        user {
          id
          nanoId
        }
        companyId
      }
      paginationInfo {
        currentPage
        firstPage
        lastPage
        limitValue
        nextPage
        outOfRange
        prevPage
        totalCount
        totalPages
      }
      sql
    }
  }
`;
